import { TemplateElement, html, toString, i18n, defineElement } from '@webtides/element-js';
import styles from './product-variant.css';
import { getSrcByBreakpoint } from '../../../elements/prod-image/prod-image';
import { getFormattedSalePrice } from '../../../../js/helper/price-model-helper';
import { getSrcByDimension } from '../../../elements/tessa-image/tessa-image';

export default class ProductVariant extends TemplateElement {
    constructor() {
        super({ shadowRender: false, styles: [styles] });
    }

    properties() {
        return {
            variant: null,
            showSubline: true,
            type: 'default', // ['small', 'default']
        };
    }

    get specs() {
        if (!this.variant || !this.variant.specCombinationKey) return '';
        const specs = '';
        const specKeys = [];
        this.variant.specCombinationKey.split('-').forEach(spec => {
            specKeys.push(spec.split(':').shift());
        });
        return specKeys
            .map(key => {
                return this.variant.specs[key].value;
            })
            .join(' | ');
    }

    watch() {
        return {
            variant: variant => {},
        };
    }

    getImageByProvider({ source, url }) {
        let detailImage;
        switch (source) {
            case 'PROD_IMAGE':
                const breakpoint = { from: 0, width: 270, height: 180 };
                detailImage = getSrcByBreakpoint(url, breakpoint);
                break;
            default:
                detailImage = getSrcByDimension({ url: url, width: 270, height: 180 });
        }
        return detailImage;
    }

    template() {
        if (!this.variant) return null;

        return this.type === 'small' ? this.templateSmall() : this.templateDefault();
    }

    templateSmall() {
        // const detailImageAlt = this.getProductVariantAlt(this.selectedVariant);
        const image = this.getImageByProvider(this.variant?.image);

        return html`
            <div class="flex flex-col md:flex-row items-center justify-center">
                <div class="w-1/2 h-full flex justify-center px-4">
                    <a href="${this.variant?.link ?? ''}">
                        <img src="${image}" alt="${this.variant?.name}" class="object-contain" />
                    </a>
                </div>
                <div class="w-full md:w-1/2 p-4 md:py-8">
                    <div class="flex-1 px-4  text-center md:text-left">
                        <a href="${this.variant?.link ?? ''}" class="font-extrabold text-black text-lg md:text-xl"
                            >${this.variant?.name}</a
                        >
                        <div class="font-light text-black md:text-lg leading-tight">${this.specs}</div>
                        <div class="font-bold text-black md:text-lg leading-tight mt-2">
                            ${getFormattedSalePrice(this.variant?.prices)}
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    templateDefault() {
        // const detailImageAlt = this.getProductVariantAlt(this.selectedVariant);
        const image = this.getImageByProvider(this.variant?.image);

        return html`
            <div class="flex flex-col md:flex-row items-center justify-center">
                <div class="w-1/2 h-full flex justify-end px-4">
                    <a href="${this.variant?.link ?? ''}">
                        <img src="${image}" alt="${this.variant?.name}" class="object-contain" />
                    </a>
                </div>
                <div class="w-full md:w-1/2 p-4 md:py-8">
                    <div class="flex-1 px-4  text-center md:text-left">
                        <a href="${this.variant?.link ?? ''}" class="font-extrabold text-black text-lg md:text-xl"
                            >${this.variant?.name}</a
                        >
                        <div class="font-light text-black md:text-lg">${this.specs}</div>
                        <div class="font-bold text-black md:text-lg">
                            ${getFormattedSalePrice(this.variant?.prices)}
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}

defineElement('product-variant', ProductVariant);
